import { NgModule } from "@angular/core";
import { InputTextModule } from "primeng/inputtext";
import { DropdownModule } from "primeng/dropdown";
import { ButtonModule } from "primeng/button";
import { CalendarModule } from "primeng/calendar";
import { AutoCompleteModule } from "primeng/autocomplete";
import { CheckboxModule } from "primeng/checkbox";
import { KeyFilterModule } from "primeng/keyfilter";
import { TabViewModule } from "primeng/tabview";
import { TableModule } from "primeng/table";
import { MultiSelectModule } from "primeng/multiselect";
import { DialogModule } from "primeng/dialog";
import { ChipsModule } from "primeng/chips";
import { RadioButtonModule } from "primeng/radiobutton";
import { InputTextareaModule } from "primeng/inputtextarea";
import { MenubarModule } from "primeng/menubar";
import { MenuModule } from "primeng/menu";
import { GMapModule } from "primeng/gmap";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { SidebarModule } from "primeng/sidebar";
import { InputMaskModule } from "primeng/inputmask";
import {TooltipModule} from 'primeng/tooltip';
import {CardModule} from 'primeng/card';
import { PasswordModule } from "primeng/password";
@NgModule({
  imports: [
    PasswordModule,
    InputTextModule,
    CardModule,
    DropdownModule,
    ButtonModule,
    CalendarModule,
    AutoCompleteModule,
    CheckboxModule,
    KeyFilterModule,
    TabViewModule,
    TooltipModule,
    TableModule,
    MultiSelectModule,
    DialogModule,
    ChipsModule,
    RadioButtonModule,
    InputTextareaModule,
    MenubarModule,
    MenuModule,
    GMapModule,
    OverlayPanelModule,
    ScrollPanelModule,
    SidebarModule,
    InputMaskModule,
  ],
  exports: [
    InputTextModule,
    CardModule,
    DropdownModule,
    ButtonModule,
    CalendarModule,
    AutoCompleteModule,
    CheckboxModule,
    KeyFilterModule,
    TabViewModule,
    TooltipModule,
    TableModule,
    MultiSelectModule,
    DialogModule,
    ChipsModule,
    RadioButtonModule,
    InputTextareaModule,
    MenubarModule,
    MenuModule,
    GMapModule,
    OverlayPanelModule,
    ScrollPanelModule,
    SidebarModule,
    InputMaskModule,
  ],
})
export class primeNg {}
